import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Investor";

import { resetDisBankState } from "../features/distributor/bank";
import { resetDisBizState } from "../features/distributor/biz";
import { resetBankState as resetIndBankState } from "../features/indinvestor/bankSliceInd";
import { resetProfState } from "../features/indinvestor/profSlice";
import { resetInstitutionalBankState } from "../features/institutionalInvestor/bankSlice";
import { resetInstitutionalBizState } from "../features/institutionalInvestor/bizSlice";
import { resetInstitutionalRepState } from "../features/institutionalInvestor/repSlice";
import { resetBankState as resetBorBankState } from "../features/merchant/bankSlice";
import { resetBizState } from "../features/merchant/biz";
import { resetAllDocuments } from "../features/merchant/doc";
import { clearState as clearMerchantState } from "../features/merchant/MerchantSlice/MerchantSlice";
import { clearState as clearPaymentState } from "../features/merchant/MerchantSlice/PaymentTrackingSlice";
import { resetRepState } from "../features/merchant/rep";
import { resetAllRegistrationDocuments } from "../features/registration/docSlice";

/**
 * All Redux reset actions for the investor app.
 * Used by performLogoutCleanup to reset all state slices on logout.
 */
export const investorResetActions: Array<() => { type: string }> = [
  resetAuthState,
  resetInstitutionalBizState,
  resetInstitutionalRepState,
  resetInstitutionalBankState,
  resetAllRegistrationDocuments,
  resetDisBizState,
  resetDisBankState,
  resetBizState,
  resetBorBankState,
  resetRepState,
  resetAllDocuments,
  resetProfState,
  resetIndBankState,
  clearMerchantState,
  clearPaymentState,
];
